/**
 * 文件说明:
 *
 * customer utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import constants from 'common/constants'

const {
    customerType,
    mingChuangTagGroupNamePrefix,
    topToyTagGroupNamePrefix,
    wowColorTagGroupNamePrefix,
} = constants

export function isWeChatType(type) {
    return type === customerType.wechat.type
}

export function isWWorkType(type) {
    return type === customerType.wwork.type
}

export function getCustomerTypeText(type, corpName) {
    if (type === customerType.wechat.type) {
        return `@${customerType.wechat.name}`
    }
    if (type === customerType.wwork.type) {
        return corpName ? `@${corpName}` : ''
    }
    return ''
}

export function getCustomerTypeSuffix(type, corpName) {
    if (type === customerType.wechat.type) {
        return <span style={{color: '#00BD6C'}}>@{customerType.wechat.name}</span>
    }
    if (type === customerType.wwork.type) {
        return corpName ? <span style={{color: '#F4A546'}}>@{corpName}</span> : ''
    }
    return ''
}

// 企业标签分类
export function sortCorpTags(corpTags) {
    const mcTags = [] // 名创
    const topToyTags = [] // toptoy
    const wowColorTags = [] // wowcolor
    const normalTags = []
    if (Array.isArray(corpTags)) {
        corpTags.forEach((tag) => {
            const groupName = tag.group_name
            if (groupName.startsWith(mingChuangTagGroupNamePrefix)) {
                mcTags.push(tag)
            } else if (groupName.startsWith(topToyTagGroupNamePrefix)) {
                topToyTags.push(tag)
            } else if (groupName.startsWith(wowColorTagGroupNamePrefix)) {
                wowColorTags.push(tag)
            } else {
                normalTags.push(tag)
            }
        })
    }
    return {mcTags, topToyTags, wowColorTags, normalTags}
}
